export default __webpack_public_path__ + "media/images/paylogos/color/visa_verified@2x-9eb0abd61351499858ff5524412b84c9.png";